

interface Props {
  onClose: () => void;
  onCallbackClick: () => void;
  onLiveChatClick: () => void;
  onCallUsClick: () => void;
  onSendEmailClick: () => void;
}


const LiveAssistance = ({
  onCallbackClick,
  onClose,
  onLiveChatClick,
  onCallUsClick,
  onSendEmailClick,
}: Props) => {

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
      <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl">
        <button
          onClick={onClose}
          className="absolute top-0 right-0 mt-2 mr-2 bg-transparent hover:bg-gray-200 text-gray-800 font-semibold py-1 px-2 rounded"
        >
          X
        </button>
        <h2 className="text-2xl font-bold text-center mb-4">Live Assistance</h2>
        <div className="border-b border-gray-300 pb-4 mb-4">
          <p className="text-sm text-center text-gray-700">
            How would you like to get in touch?
          </p>
        </div>
        <div className="flex justify-between space-x-4">
          {/* Option 1 */}
          <button onClick={onCallUsClick} className="flex-1 flex flex-col items-center justify-center bg-white p-4 shadow rounded border border-gray-300">
            <img src="phone.svg" alt="Phone" className="h-16 w-16 mb-4" />
            <p className="text-sm font-medium m-0">Call Us</p>
          </button>
          {/* Option 2 */}
          <button
            onClick={onLiveChatClick}
            className="flex-1 flex flex-col items-center justify-center bg-white p-4 shadow rounded border border-gray-300"
          >
            <img src="message.png" alt="Message" className="h-16 w-16 mb-4" />
            <p className="text-sm font-medium m-0">Live Chat</p>
          </button>
          {/* Option 3 */}
          <button onClick={onSendEmailClick} className="flex-1 flex flex-col items-center justify-center bg-white p-4 shadow rounded border border-gray-300 ">
            <img src="email.png" alt="Email" className="h-16 w-16 mb-4" />
            <p className="text-sm font-medium m-0">Send Email</p>
          </button>
          {/* Option 4 */}
          <button
            onClick={onCallbackClick}
            className="flex-1 flex flex-col items-center justify-center bg-white p-4 shadow rounded border border-gray-300"
          >
            <img src="callback.png" alt="Callback" className="h-16 w-16 mb-4" />
            <p className="text-sm font-medium m-0">Receive a Call</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiveAssistance;
export {};
